import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Accordion, Form, Icon } from "semantic-ui-react";

import {
  dailyPatternsAttributes,
  storeAttributes,
} from "../../../store/reducers/dataReducer";
import * as actions from "../../../store/actions/actions";
import {
  recentTrendsAttributes,
  reportTypes,
} from "../../../store/reducers/reports";

const ReportsSidePanelStoreAttributes = (props) => {
  const { type, selectedAttributes } = props;

  const dispatch = useDispatch();

  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const selectHandler = (event, data) => {
    dispatch(actions.selectAttribute(data.value));
  };

  const clickHandler = (event, data) => {
    dispatch(actions.clickAttribute(data.value));
  };

  let content = "";

  if (type === reportTypes.compareStores.value) {
    content = (
      <Accordion exclusive>
        <Form>
          {Object.entries(storeAttributes).map(
            ([groupName, attributes], index) => (
              <React.Fragment key={index}>
                <Accordion.Title
                  active={activeIndex === index}
                  index={index}
                  onClick={handleClick}
                >
                  <Icon name="dropdown" />
                  {groupName}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index}>
                  <Form.Group grouped>
                    {attributes.map((a, index) => (
                      <Form.Checkbox
                        key={index}
                        label={a}
                        name="attributes"
                        type="checkbox"
                        value={a}
                        disabled={
                          selectedAttributes.length === 6 &&
                          !selectedAttributes.includes(a)
                        }
                        checked={selectedAttributes.includes(a)}
                        onChange={selectHandler}
                      />
                    ))}
                  </Form.Group>
                </Accordion.Content>
              </React.Fragment>
            )
          )}
        </Form>
      </Accordion>
    );
  } else if (type === reportTypes.analyzeDailyPatterns.value) {
    content = (
      <Form>
        <Form.Group grouped>
          {dailyPatternsAttributes.map((a, index) => (
            <Form.Checkbox
              key={index}
              label={a}
              name="attributes"
              type="checkbox"
              value={a}
              checked={selectedAttributes.includes(a)}
              onChange={selectHandler}
            />
          ))}
        </Form.Group>
      </Form>
    );
  } else {
    content = (
      <Accordion exclusive>
        <Form>
          {Object.entries(recentTrendsAttributes).map(
            ([groupName, attributes], index) => (
              <React.Fragment key={index}>
                <Accordion.Title
                  active={activeIndex === index}
                  index={index}
                  onClick={handleClick}
                >
                  <Icon name="dropdown" />
                  {groupName}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index}>
                  <Form.Group grouped>
                    {attributes.map((a, index) => (
                      <Form.Radio
                        key={index}
                        label={a}
                        name="attributes"
                        type="radio"
                        value={a}
                        checked={selectedAttributes.includes(a)}
                        onChange={clickHandler}
                      />
                    ))}
                  </Form.Group>
                </Accordion.Content>
              </React.Fragment>
            )
          )}
        </Form>
      </Accordion>
    );
  }

  return (
    <div className="reports-panel-attributes">
      <div className="reprots-panel-section-title">
        {type === reportTypes.analyzeRecentTrends.value
          ? "Select Attribute"
          : "Select Attributes"}
      </div>
      {content}
    </div>
  );
};

export default React.memo(ReportsSidePanelStoreAttributes);
